module.exports = __webpack_public_path__ + "img/arrow_icon.9c277af8.svg";